var map = {
  "./pl.messages.tsx": [
    "99588",
    [
      6573
    ]
  ],
  "./cs.messages.tsx": [
    "45858",
    [
      4367
    ]
  ],
  "./en.messages.tsx": [
    "22027",
    [
      9188
    ]
  ],
  "./hu.messages.tsx": [
    "72543",
    [
      2468
    ]
  ],
  "./de.messages.tsx": [
    "40467",
    [
      6704
    ]
  ],
  "./it.messages.tsx": [
    "69837",
    [
      8286
    ]
  ],
  "./sk.messages.tsx": [
    "48330",
    [
      9047
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 50944;
module.exports = __rspack_async_context;
